import React, { useState } from 'react'
import MenuMain from './MenuMain'
import { Drawer } from '../Plugin'
import { Button, RadioButton } from '../Shared'
import { Bar, Logo, Date } from '../../assets/icons'
import Banner from '../../assets/images/banner.jpg'
import { persianDaysArray, persianMonths } from '../../Utils/PersianDaysArray'
import moment from 'moment-jalaali';
import { useDispatch, useSelector } from 'react-redux';

const certText = 'با مجوز رسمی از اتحادیه طلا و جواهر تهران'
const HeaderMain = props => {

	const dispatch = useDispatch();
	///const [openDrawer, isOpenDrawer] = useState(false);
	const [enToFa, setEnToFa] = useState(false);
	const isFaNum = useSelector(
		(state) => state.persistedParams.isFaNum
	)
	const isOpenDrawer = useSelector(
		(state) => state.persistedParams.isOpenDrawer
	)

	function toggleDrawer() {
		dispatch({
			type: "IS_OPEN_DRAWER",
			payload: true
		})
	}

	function closeDrawer() {
		dispatch({
			type: "IS_OPEN_DRAWER",
			payload: false
		})
	}

	function getDay() {
		const day = moment().day();
		const month = moment().jMonth()
		const dayInMonth = moment().format('jDD')
		const year = moment().format('jYYYY')
		const dayName = persianDaysArray[day]
		const monthName = persianMonths[month]
		return `${dayName} ${dayInMonth} ${monthName} ${year}`;
	}

	const refresh =()=>{
		if ("caches" in window) {
			caches.keys().then((names) => {
			  names.forEach((name) => {
				caches.delete(name);
			  });
			});
		}
		window.location.reload(true);
	}

	return (
		<>
			<header className="headerMain">
				<div className="_menu">
					<Button onClick={toggleDrawer}>
						<Bar />
					</Button>
				</div>
				<div className="_logo">
					<Button>
						<Logo />
					</Button>
				</div>
				<div className="_banner">
					<img src={Banner} alt="" />
				</div>
				<time
					className="_time"
				>
					{getDay()}
					<Date className="_icon" />
				</time>
				<div className="_refresh">
					<button onClick={refresh}>
						<i class="fa fa-refresh" style={{color:'#847e7e'}}></i>
					</button>
				</div>
				<p className="_cert">{certText}</p>
			</header>
			<Drawer
				direction="_right"
				isOpen={isOpenDrawer}
				closeDrawer={closeDrawer}
			>
				<MenuMain />
			</Drawer>
		</>
	)

}


export default HeaderMain
